import React from 'react';
import { Bell, BellOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePushNotifications } from '@/hooks/usePushNotifications';
import { toast } from 'sonner';

export function PushToggle() {
  const { isSupported, isSubscribed, permission, subscribe, unsubscribe, serverAvailable } = usePushNotifications();

  // Hide toggle entirely if browser doesn't support push OR the server has push disabled
  if (!isSupported || serverAvailable === false) return null;

  const handleToggle = async () => {
    if (isSubscribed) {
      await unsubscribe();
      toast.success('Notificacions desactivades');
    } else {
      const ok = await subscribe();
      if (ok) {
        toast.success('Notificacions activades! Rebràs alertes importants.');
      } else if (permission === 'denied') {
        toast.error('Les notificacions estan bloquejades. Activa-les a la configuració del navegador.');
      }
    }
  };

  return (
    <Button
      variant={isSubscribed ? "default" : "outline"}
      size="sm"
      onClick={handleToggle}
      data-testid="push-toggle-btn"
      className={`gap-1.5 ${isSubscribed ? 'bg-[#7B2D3F] hover:bg-[#5B1D2F] text-white' : ''}`}
    >
      {isSubscribed ? <Bell className="w-3.5 h-3.5" /> : <BellOff className="w-3.5 h-3.5" />}
      {isSubscribed ? 'Notificacions actives' : 'Activar notificacions'}
    </Button>
  );
}
